import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../assets/js/LanguageContext';
import Accordion from '../common/Accordion';
import SectionEyebrow from '../common/SectionEyebrow';

const FAQ = () => {
  const { t } = useLanguage();

  const questions = [1, 2, 3, 4, 5].map((n) => ({
    id: `faq-${n}`,
    title: t(`pricing_faq_q${n}`),
    content: <p>{t(`pricing_faq_a${n}`)}</p>
  }));

  return (
    <section className="section-band">
      <div className="section-band__inner">
        <div className="tp-faq">
          <div className="section-band__head">
            <SectionEyebrow>{t('pricing_faq_title')}</SectionEyebrow>
            <p className="section-band__lead">{t('pricing_faq_lead')}</p>
          </div>

          <Accordion items={questions} defaultValue="faq-1" />

          <p className="tp-faq__more">
            {t('pricing_faq_more')}{' '}
            <Link to="/contact-us" className="tp-faq__link">{t('pricing_faq_contact')}</Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
